import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import Icon from '../../../components/Icon';
import { withTranslation } from 'react-i18next';
class FileIcon extends Component {
    render() {
        const { file, onLoadClick, blocksLength, isTruncated, t } = this.props;
        const showLoadMore = isTruncated || blocksLength === 0;
        const iconName = showLoadMore ? 'file-dashed-line' : 'file-code';
        const icon = _jsx(Icon, { name: iconName, className: "report-detail__icon mr-2" });
        if (!showLoadMore) {
            return icon;
        }
        const title = t('tooManyIssues') + ' ' + t('loadIssues');
        return (_jsx("button", { className: "report-detail__load-file", onClick: () => onLoadClick(file.filePath), title: title, children: icon }));
    }
}
FileIcon.defaultProps = {
    blocksLength: 0,
    isTruncated: false,
};
export default withTranslation()(FileIcon);
